const OMNIBUS_SELECTOR = "omnibus-lowest-price";
const PRICE_TO_HIDE = 0;

// The price is 0 when all its digits are 0, so currency, symbol position and separators do not matter
function isPriceToHide(text) {
  const digits = text.split(":").pop().replace(/\D/g, "");
  return digits !== "" && Number(digits) === PRICE_TO_HIDE;
}

function updateBestPriceVisibility() {
  document.querySelectorAll(OMNIBUS_SELECTOR).forEach((element) => {
    element.hidden = isPriceToHide(element.textContent);
  });
}

// The observer sees the whole body, so only mutations inside a block or adding one trigger the re-check
function isRelatedToBlock(mutation) {
  const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
  if (target && target.closest(OMNIBUS_SELECTOR)) return true;

  return [...mutation.addedNodes].some(
    (node) => node instanceof Element && (node.matches(OMNIBUS_SELECTOR) || node.querySelector(OMNIBUS_SELECTOR)),
  );
}

function handleMutations(mutationList) {
  if (mutationList.some(isRelatedToBlock)) updateBestPriceVisibility();
}

// Blocks are inserted later (recommendations, collection filters), so the whole body is observed
function observeBestPriceBlocks() {
  updateBestPriceVisibility();

  const config = { childList: true, subtree: true, characterData: true };
  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, config);
}

observeBestPriceBlocks();
